import { Link } from "react-router-dom";

interface SEOArticleItem {
  slug: string;
  title: string;
  description: string;
  imageUrl: string;
}

const seoArticles: SEOArticleItem[] = [
  {
    slug: "/quest-ce-que-hipobuy-spreadsheet",
    title: "Qu'est-ce que le Hipobuy Spreadsheet ?",
    description: "Définition, concept et histoire de l'outil de suivi e-commerce qui révolutionne la gestion de produits en ligne.",
    imageUrl: "https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20next%20to%20tablet%20on%20cream%20desk%2C%20warm%20coffee%20nearby%2C%20soft%20morning%20light%2C%20minimal%20workspace%2C%20Scandinavian%20editorial%20photography&width=400&height=300&seq=seo-card-questce-v3&orientation=landscape",
  },
  {
    slug: "/comment-ca-fonctionne-hipobuy-spreadsheet",
    title: "Comment ça fonctionne ?",
    description: "Guide détaillé du fonctionnement du hipobuy spreadsheet, de la configuration initiale à l'optimisation avancée.",
    imageUrl: "https://readdy.ai/api/search-image?query=Step%20by%20step%20diagram%20sketched%20on%20cream%20paper%20beside%20laptop%2C%20warm%20workspace%2C%20minimal%20desk%20setup%2C%20soft%20natural%20lighting%2C%20Scandinavian%20style&width=400&height=300&seq=seo-card-fonctionne-v3&orientation=landscape",
  },
  {
    slug: "/fonctionnalites-hipobuy-spreadsheet",
    title: "Fonctionnalités principales",
    description: "Explorez toutes les fonctionnalités : suivi produit, analyse prix, automatisation, reporting et plus encore.",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20UI%20mockup%20cards%20with%20icons%20displayed%20on%20cream%20background%2C%20modern%20app%20interface%20concept%2C%20soft%20warm%20lighting%2C%20minimal%20tech%20aesthetic%2C%20Scandinavian%20design&width=400&height=300&seq=seo-card-fonctionnalites-v3&orientation=landscape",
  },
  {
    slug: "/tarifs-hipobuy-spreadsheet",
    title: "Tarifs et formules",
    description: "Découvrez les tarifs du hipobuy spreadsheet et choisissez la formule adaptée à votre activité e-commerce.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20pricing%20cards%20arranged%20on%20cream%20wooden%20desk%2C%20warm%20morning%20light%2C%20minimal%20professional%20presentation%2C%20clean%20Scandinavian%20aesthetic&width=400&height=300&seq=seo-card-tarifs-v3&orientation=landscape",
  },
  {
    slug: "/securite-confidentialite-hipobuy-spreadsheet",
    title: "Sécurité et confidentialité",
    description: "Comment vos données e-commerce sont protégées : chiffrement, authentification et mesures de sécurité.",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20padlock%20icon%20on%20warm%20cream%20surface%20with%20soft%20natural%20lighting%2C%20cybersecurity%20concept%2C%20clean%20trust%20aesthetic%2C%20professional%20photography&width=400&height=300&seq=seo-card-securite-v3&orientation=landscape",
  },
  {
    slug: "/analyse-concurrents-hipobuy-spreadsheet",
    title: "Analyse des concurrents",
    description: "Comment analyser vos concurrents, comparer les prix et optimiser votre positionnement e-commerce.",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20chess%20pieces%20on%20cream%20marble%20surface%2C%20soft%20directional%20lighting%2C%20elegant%20business%20strategy%20concept%2C%20clean%20professional%20composition&width=400&height=300&seq=seo-card-concurrents-v3&orientation=landscape",
  },
  {
    slug: "/hipobuy-spreadsheet-vs-excel",
    title: "Hipobuy Spreadsheet vs Excel",
    description: "Comparaison détaillée : découvrez pourquoi les vendeurs abandonnent Excel pour le hipobuy spreadsheet.",
    imageUrl: "https://readdy.ai/api/search-image?query=Old%20paper%20ledger%20next%20to%20modern%20tablet%20on%20cream%20desk%2C%20warm%20light%2C%20past%20versus%20future%20concept%2C%20minimal%20workspace%2C%20Scandinavian%20style&width=400&height=300&seq=seo-card-vs-excel-v3&orientation=landscape",
  },
  {
    slug: "/hipobuy-spreadsheet-vs-notion",
    title: "Hipobuy Spreadsheet vs Notion",
    description: "Comparaison entre hipobuy spreadsheet et Notion pour le suivi e-commerce. Lequel choisir ?",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20elegant%20notebooks%20side%20by%20side%20on%20cream%20wooden%20surface%2C%20warm%20light%2C%20comparison%20concept%2C%20minimal%20clean%20workspace%2C%20Scandinavian%20photography&width=400&height=300&seq=seo-card-vs-notion-v3&orientation=landscape",
  },
  {
    slug: "/tutoriel-hipobuy-spreadsheet",
    title: "Tutoriel complet",
    description: "Guide pratique pour maîtriser le hipobuy spreadsheet, des premiers pas aux fonctionnalités avancées.",
    imageUrl: "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20keyboard%20with%20coffee%20and%20plant%20on%20warm%20cream%20desk%2C%20cozy%20workspace%2C%20soft%20morning%20light%2C%20minimal%20home%20office%2C%20Scandinavian%20style&width=400&height=300&seq=seo-card-tutoriel-v3&orientation=landscape",
  },
];

export default function SEOArticles() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-16 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="text-xs font-medium text-foreground-400 uppercase tracking-[0.2em]">
            Ressources
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Guides et <span className="italic">articles</span>
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg">
            Approfondissez vos connaissances sur le <strong>hipobuy spreadsheet</strong> avec nos articles détaillés.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group block rounded-2xl overflow-hidden bg-background-100 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5 leading-snug group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{article.description}</p>
                <div className="mt-3 flex items-center gap-1.5 text-xs text-primary-600 font-medium whitespace-nowrap">
                  Lire l'article
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}